import { useState } from 'react';
import ReviewTopicModel from '../models/ReviewTopicModel';
import { ResponseException } from '../models';
import { AxiosPrivate } from '../utils/axios';
import { SubmissionType } from '@mvrb-frontend/shared-ui';

export const useManageReviewTopics = () => {
  const [isSubmittingTopics, setSubmittingTopics] = useState(false);
  const [submitTopicsErrors, setSubmitTopicsErrors] = useState<string[]>([]);

  const submitReviewTopic = async (reviewTopic: ReviewTopicModel, submissionType: SubmissionType) => {
    try {
      setSubmittingTopics(true);
      let updateRes = null;
      switch (submissionType) {
        case SubmissionType.Add:
          updateRes = await AxiosPrivate.post(`/topics`, reviewTopic);
          break;
        case SubmissionType.Update:
          updateRes = await AxiosPrivate.patch(`/topics/${reviewTopic.id}`, reviewTopic);
          break;
        case SubmissionType.Delete:
          updateRes = await AxiosPrivate.delete(`/topics/${reviewTopic.id}`);
          break;
      }
      return updateRes;
    } catch (e) {
      setSubmitTopicsErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setSubmittingTopics(false);
    }
  };

  return {
    isSubmittingTopics,
    submitTopicsErrors,
    submitReviewTopic,
  };
};
